import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "Experience iYuga on Desktop",
  description: "",
  type:"default"
};

const mobileViewDialogSlice = createSlice({
  name: "mobileViewDialog",
  initialState,
  reducers: {
    openMobileViewDialog: (state, action) => {
      state.isOpen = true;
      if (action.payload?.title) {
        state.title = action.payload.title;
      }
        if (action.payload?.description) {
          state.description = action.payload.description;
        }
        if (action.payload?.type) {
          state.type = action.payload.type;
        }
        if (action.payload?.wheel) {
          state.wheel = action.payload.wheel;
        }
    },
    closeMobileViewDialog: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openMobileViewDialog, closeMobileViewDialog } =
  mobileViewDialogSlice.actions;
export default mobileViewDialogSlice.reducer;
